import { map, flatten, uniqBy, isEqual } from 'lodash'
import { WhatsOnRange } from '../../../../types/whats-on'

export const filterRanges = (
  ranges: WhatsOnRange[],
  selectedFilter?: string
): WhatsOnRange[] =>
  selectedFilter
    ? ranges.filter(range => range.slug === selectedFilter)
    : ranges

export const calucateCount = (ranges: WhatsOnRange[]): number =>
  uniqBy(flatten(map(ranges, 'items')), 'slug').length

interface Setter {
  (selection: string[], action: string): void
}
interface OnSelectionChangeFunc {
  (selection: string[]): void
}
function makeUpdater(
  arrayParamVal: string[],
  arrayParamSetter: Setter,
  arrayParamOptions: string[]
): OnSelectionChangeFunc {
  return function (newSelection) {
    const processedNewSelection = [...newSelection]
      .sort()
      .filter(val => arrayParamOptions.includes(val))
    if (!isEqual(arrayParamVal, processedNewSelection)) {
      arrayParamSetter(processedNewSelection, 'pushIn')
    }
  }
}
export const makeMultiFilterProps = (
  values: string[],
  setter: Setter,
  options: string[]
): {
  filterOptions: string[]
  selectedOptions: string[]
  onSelectionChange: OnSelectionChangeFunc
} => {
  const definiteValues = values || []
  const definiteOptions = options || []
  return {
    filterOptions: definiteOptions,
    selectedOptions: definiteValues,
    onSelectionChange: makeUpdater(definiteValues, setter, definiteOptions),
  }
}
